import { resolveElements } from '../utils/resolve-elements.es.js';
import { isFunction } from '@motionone/utils';
var thresholds = {
  any: 0,
  all: 1
};
function inView(elementOrSelector, onStart) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    root = _ref.root,
    rootMargin = _ref.margin,
    _ref$amount = _ref.amount,
    amount = _ref$amount === void 0 ? "any" : _ref$amount;
  /**
   * If this browser doesn't support IntersectionObserver, return a dummy stop function.
   * Default triggering of onStart is tricky - it could be used for starting/stopping
   * videos, lazy loading content etc. We could provide an option to enable a fallback, or
   * provide a fallback callback option.
   */
  if (typeof IntersectionObserver === "undefined") {
    return function () {};
  }
  var elements = resolveElements(elementOrSelector);
  var activeIntersections = new WeakMap();
  var onIntersectionChange = function onIntersectionChange(entries) {
    entries.forEach(function (entry) {
      var onEnd = activeIntersections.get(entry.target);
      /**
       * If there's no change to the intersection, we don't need to
       * do anything here.
       */
      if (entry.isIntersecting === Boolean(onEnd)) return;
      if (entry.isIntersecting) {
        var newOnEnd = onStart(entry);
        if (isFunction(newOnEnd)) {
          activeIntersections.set(entry.target, newOnEnd);
        } else {
          observer.unobserve(entry.target);
        }
      } else if (onEnd) {
        onEnd(entry);
        activeIntersections["delete"](entry.target);
      }
    });
  };
  var observer = new IntersectionObserver(onIntersectionChange, {
    root: root,
    rootMargin: rootMargin,
    threshold: typeof amount === "number" ? amount : thresholds[amount]
  });
  elements.forEach(function (element) {
    return observer.observe(element);
  });
  return function () {
    return observer.disconnect();
  };
}
export { inView };